/**
 * The Pricing module's permission vocabulary.
 *
 * Its only screen today is the read-only Pricing settings page — the config and rate cards the
 * engine prices on — so `view` is all that is checked. `manage` is declared now so that making
 * the settings editable (or approving a rate-card sync) is a grant, not a rebuild.
 *
 * Not granted to the All Users group, nor to the quoting groups: the audience is the one that
 * had `quoting:manage` before pricing was its own module — Administrators, who get every
 * module's highest level automatically.
 */
import { defineModulePermissions } from '@noissue/authz';

export const PRICING = defineModulePermissions({
  id: 'pricing',
  name: 'Pricing',
  icon: 'badge-dollar-sign',
  permissions: {
    view: {
      label: 'View pricing settings',
      description: 'See the pricing configuration and rate cards quotes are priced on.',
    },
    manage: {
      label: 'Manage pricing',
      description: 'Change pricing configuration and rate cards (not yet editable).',
    },
  },
  visibility: 'view',
  levels: [
    { key: 'view', label: 'View', grants: ['view'] },
    { key: 'manage', label: 'Manage', grants: ['view', 'manage'] },
  ],
});
